import React from "react";
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import parallaxStyle from "assets/jss/material-kit-react/components/parallaxStyle.jsx"

import earlyAdopterCta from "data/early-adopter-cta.json";

// Sections for this page
import CTASection from "components/CTASection/CTASection.jsx";

import compassBlue from "assets/img/compass-blue.jpg";
import CompassBlue from "components/Background/CompassBlue.jsx";
const earlyAdopterStyle = {

};

class EarlyAdopterCTA extends React.Component {
  render() {
    const { classes, listIds, ...rest } = this.props;
    return (
      <CompassBlue>
        <CTASection cta={earlyAdopterCta} listIds={[28].concat(listIds)} filterOpacity="0.3"/>
      </CompassBlue>
    );
  }
}

export default withStyles(earlyAdopterStyle)(EarlyAdopterCTA);
